//---------------------------------
// create new character item entry
//---------------------------------
export default function createNewCharacterItemEntry({
  id, // temp id used for tracking
  name,
  value,
  character = null,
} = {}) {
  console.log('-----------------------')
  console.log('IN createNewCharacterItemEntry')

  let character_id = null
  if (character && typeof character === 'object') {
    character_id = character.id
  }
  //------------------
  // define structure
  //------------------
  let count = {
       ...(character ? { character: character_id } : {}),
    id: id, // temp id used for tracking
    name: name,
    value: value,
  }
  return count
}
